import {useState} from "react";

/**
 * Custom hook for manage modal
 *
 */

export default function useModal(initialState) {
  const [modals, setModals] = useState(initialState);

  const closeModal = (modalName) => {
    setModals((prevState) => ({
      ...prevState,
      [modalName]: { state:false },
    }));
  };

  const updateModal = (modalName, newValue) => {
    setModals((prevState) => ({
      ...prevState,
      [modalName]: newValue,
    }));
  };

  return [modals, updateModal, closeModal];
}
